module.exports = __webpack_public_path__ + "static/media/linkedin.4f8a05c4.png";